import React, { useState, useEffect } from 'react'

const Rating = ({ hero, progress, handleNext, name, checkForRedirect }) => {
    const [ rating, setRating ] = useState(3)
    const [ vidSrc, setVidSrc ] = useState()

    useEffect(() => { 
        setVidSrc(`https://www.youtube.com/embed/${hero.shortId}?autoplay=1`)
        setRating(3)
    }, [hero]);

    useEffect(() => { checkForRedirect() }, [name, checkForRedirect])

    const handleRateChange = e => {
        setRating(e.target.value)
    }
    return (
        <div> 
            
            <p className="progress">Rating Hero {progress.toUpperCase()}</p>
            <h5>{name}, how do you rate <br className="portrait-wrap"/><span className="feature-text">{hero.name}</span>?</h5>
            <div className="rating-container">
                <div className="rating-info">
                    <iframe title="hero-vid" width="100%" height="100%" src={vidSrc}/>
                </div>

                <div className="rating-interface">
                    <div className="rating-display">
                        <p>Rating: <span className="feature-text">{rating}</span> / 5</p>                    
                    </div>
                    <div id="rating-input">
                        <input onChange={handleRateChange} className="slider" type="range" min="1" max="5" value={rating} list="tickmarks"/>
                        <datalist id="tickmarks">
                            <option value="1 to 5">1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                        </datalist>
                    </div>
                    <div>
                        <button onClick={() => handleNext(rating)}>Next</button>
                    </div>
                </div>
            
            </div>
        </div>
    )
}

export default Rating
